function handleApplyClick(method) {
  this.setFilterVisibility();
}
export default handleApplyClick;
